<div class="main-page container">
  <fc-bread-crumb-navigation [navigationString]="'Manage Info / App Config / Edit Value'"></fc-bread-crumb-navigation>
  <h1>{{ appConfigForm.value.description }}</h1>
  <mat-divider>&nbsp;</mat-divider>
  <div class="main-panel">
    <div class="error-message">{{ error }}</div>
    <form [formGroup]="appConfigForm" fcFormUnloadWarning>
      <input formControlName="id" type="hidden" />
      <div class="form-container">
        <mat-form-field class="w-50-2">
          <mat-label>Value</mat-label>
          <input [attr.disabled]="isSuperAdmin ? null : ''" formControlName="value" id="value" matInput type="text" />
        </mat-form-field>
        <mat-divider>&nbsp;</mat-divider>
        <button
          (click)="onSubmit()"
          [disabled]="!allowSave"
          class="button"
          color="primary"
          data-cy="submit-button"
          mat-raised-button>
          Update Value
        </button>
      </div>
    </form>
  </div>
  <fc-spinner [show]="false" name="app-config-spinner"></fc-spinner>
</div>
